export default __webpack_public_path__ + "static/robotbee-93b92ccd91a7f9287f936540448f2c42.svg";